<template>
  <div>
    <br />
    <vs-row vsW="12" style=" margin-bottom: 10px">
      <vs-col vsType="flex" vsJustify="center" vsAlign="center" vsLg="2" vsSm="4" vsXs="12"></vs-col>
      <vs-col vsType="flex" vsJustify="center" vsAlign="center" vsLg="2" vsSm="2" vsXs="12"></vs-col>
      <vs-col vsType="flex" vsJustify="center" vsAlign="center" vsLg="2" vsSm="2" vsXs="12"></vs-col>
      <vs-col vsType="flex" vsJustify="center" vsAlign="center" vsLg="2" vsSm="2" vsXs="12"></vs-col>
      <vs-col vsType="flex" vsJustify="flex-end" vsAlign="flex-end" vsLg="4" vsSm="4" vsXs="12">
        <vs-button id="selecttime" class="mt-3 w-1/3" @click="print()">Print</vs-button>
        <v-select
          id="selecttime"
          v-model="selectTimeIntervel"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          :options="intervel"
          class="w-full p-1"
          label="name"
        />
      </vs-col>
    </vs-row>
    <div id="printMe" class="testtest">
      <center>
        <table>
          <tbody>
            <tr>
              <td>
                <img
                  src="https://upload.wikimedia.org/wikipedia/th/0/01/%E0%B8%95%E0%B8%A3%E0%B8%B2%E0%B8%81%E0%B8%A3%E0%B8%A1%E0%B8%AA%E0%B8%A3%E0%B8%A3%E0%B8%9E%E0%B8%AA%E0%B8%B2%E0%B8%A1%E0%B8%B4%E0%B8%95.png"
                  alt
                  width="100px"
                  height="110px"
                />
              </td>
              <td>
                <center>
                  <h2>ระบบตรวจสอบและติดตามเรือขนส่งน้ำมัน</h2>
                  <h2>สำนักตรวจสอบป้องกันและปราบปราม กรมสรรพสามิต</h2>
                </center>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <table style="border: 1px solid; margin-bottom: 10px; width: 900px;">
          <thead>
            <tr style="border-top: 1px solid;">
              <td>
                ชื่อเรือ
                <br />report Name
              </td>
              <td>{{ report.name || "-" }}</td>

              <td>
                นามเรียกขาน
                <br />Call Sign
              </td>
              <td>{{ report.call_sign || "-" }}</td>

              <td>บริษัท</td>
              <td>{{ report.vendor_id || "-" }}</td>
            </tr>
            <tr>
              <td>
                หมายเลขเรือ
                <br />MMSI/IMO
              </td>
              <td>
                {{ report.mmsi || "-" }}
                <br />
                {{ report.imo_number || "-" }}
              </td>

              <td>
                สถานะเครื่อง AIS
                <br />AIS Status
              </td>
              <td v-if="report.position_reports">Online</td>
              <td v-else>Offline</td>
              <td>
                สัญชาติเรือ
                <br />MID
              </td>
              <td>
                {{ report.mid.name || "-" }}
                <br />
                {{ report.mid.code || "-" }}
              </td>
            </tr>
            <tr style="border-bottom: 1px solid;">
              <td>
                ประเภทเรือ
                <br />Ship Type
              </td>
              <td>{{ report.ship_type.name }}</td>

              <td>
                ความยาวเรือ
                <br />Length
              </td>
              <td>{{ report.length || "-" }}</td>

              <td>
                ความกว้างเรือ
                <br />Breadth
              </td>
              <td>{{ report.beam || "-" }}</td>
            </tr>
          </thead>
        </table>
        <VesselTrackingHistory
          :data="data"
          :hide="hide"
          :callback="onSelectRow"
          :vasselReport="report"
        />
        <!-- <div id="map" style=" border: 0;height: 400px; width: 900px; padding: 0px;"></div> -->
        <table style="border: 1px solid; margin-top: 10px; width: 900px;">
          <thead>
            <tr style="border-top: 1px solid; border-bottom: 1px solid;">
              <td align="center" style="border: 1px solid; width: 100px;">วันที่</td>
              <td align="center" style="border: 1px solid; width: 100px;">เวลา</td>
              <td align="center" style="border: 1px solid; width: 200px;">
                ตำแหน่ง
                <br />(ละติจูด /ลองติจูด )
              </td>
              <td align="center" style="border: 1px solid; width: 100px;">
                ความเร็ว
                <br />(Knot)
              </td>
              <td align="center" style="border: 1px solid; width: 100px;">
                ทิศทาง
                <br />(องศา)
              </td>
              <!-- <td align="center" style="border: 1px solid; width: 100px;">
                การทำงานของ battery back up
              </td>
              <td align="center" style="border: 1px solid; width: 100px;">
                สถานะสัญญาณวิทยุ
              </td>
              <td align="center" style="border: 1px solid; width: 100px;">
                สถานะการเข้ารับน้ำมัน
              </td> -->
              <td align="center" style="border: 1px solid;">หมายเหตุ</td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in report.position_reports"
              :key="index"
              :class="{active : activeEl == index && data.length > 1}"
              style="border-top: 1px solid; border-bottom: 1px solid;"
            >
              <td align="center" style="border: 1px solid;">{{ item.record_time|sumdate }}</td>
              <td align="center" style="border: 1px solid;">{{ item.record_time|sumtime }}</td>
              <td align="center" style="border: 1px solid;">
                LAT {{ item.latitude }}
                <br />
                LON {{ item.longitude }}
              </td>
              <td align="center" style="border: 1px solid;">{{ item.speed_over_ground }}</td>
              <td align="center" style="border: 1px solid;">{{ item.true_heading }}</td>
              <!-- <td align="center" style="border: 1px solid;">{{ batteryStatus(item.battery_status) }}</td>
              <td align="center" style="border: 1px solid;">{{ wiresStatus(item.ais_loss) }}</td>
              <td align="center" style="border: 1px solid;">{{ refuelStatus(item.refuel_event) }}</td> -->
              <td v-if="item.east12||item.west12" align="center" style="border: 1px solid;" >อยู่ในเขต 12 ไมล์ทะเล</td>
              <td v-else-if="item.east24||item.west24" align="center" style="border: 1px solid;" >อยู่ในเขต 12-24 ไมล์ทะเล</td>
              <td v-else align="center" style="border: 1px solid;">ออกนอกเขต 12-24 ไมล์ทะเล</td>
            </tr>
          </tbody>
        </table>
      </center>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import vSelect from "vue-select";
import { mapState } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VesselTrackingHistory from "./vesselTrackingHistory";
import { API_BASE_URL } from "@/constants";

export default {
  components: {
    VuePerfectScrollbar,
    VesselTrackingHistory,
    "v-select": vSelect
  },
  filters: {
    sumdate: function(string) {
      if (string != null) {

        let day = string.substring(0, 2);
        let mount = string.substring(3, 5);
        let year = string.substring(6, 10);
        let sumYear = parseInt(year) + 543;
        console.log("string ", string, year, sumYear);
        let date = day + "/" + mount + "/" + sumYear;
        return date;
      } else {
        return string;
      }
    },
    sumtime: function(string) {
      if (string != null) {
        return string.substring(11, 19);
      } else {
        return string;
      }
    }
  },
  data() {
    return {
      selectTimeIntervel: {
        id: 11,
        name: "1 day",
        time: 86400
      },
      hide: false,
      report: {
        mid: {},
        ship_type: {}
      },
      google: null,
      geocoder: null,
      map: null,
      output: null,
      accessEmail: "",
      accessToken: "",
      urlReport: "",
      markers: [],
      reportShiptype: "",
      reportFromDate: "",
      reportToDate: "",
      test: "",
      data: [],
      activeEl: 0
    };
  },
  computed: {
    ...mapState({
      intervel: state => state.vesselHistory.intervel
    })
  },
  watch: {
    selectTimeIntervel(val) {
      this.getReports(val);
    }
  },
  created() {
    // console.log(this.$route.query.interval);
    const time = this.$route.query.interval;
    if (time) {
      const selectTimeIntervel = this.intervel.filter(
        item => item.time == time
      )[0];
      this.selectTimeIntervel = selectTimeIntervel;
    }
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    this.urlReport = JSON.parse(localStorage.getItem("detailReport"));
    this.reportShiptype = JSON.parse(localStorage.getItem("reportShiptype"));
    this.reportFromDate = JSON.parse(localStorage.getItem("reportFromDate"));
    this.reportToDate = JSON.parse(localStorage.getItem("reportToDate"));
    this.$store.dispatch("updateTitlePage", "Detail report");
    this.getReports();
  },
  methods: {
    getReports(val = {}) {
      const interval = val.time || this.selectTimeIntervel.time;
      const url = `${API_BASE_URL}${this.urlReport}`;
      this.$vs.loading();
      axios
        .get(url, {
          params: {
            interval
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          this.report = response.data;
          this.getLatlng(response.data);
        })
        .catch(error => {
          console.log("Error call apis :", error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    batteryStatus(status) {
      return status ? "แบตเตอรี่back up ทำงาน" : "ปกติ";
    },
    wiresStatus(status) {
      return status ? "ผิดปกติ" : "ปกติ";
    },
    refuelStatus(status) {
      if (status == 1 || status == '1') {
        return "เข้าเขตเรือรับน้ำมัน";
      } else if (status == 2 || status == '2') {
        return "เข้ารับน้ำมัน";
      } else if (status == 3 || status == '3') {
        return "ออกจากการเข้ารับน้ำมัน";
      } else if (status == 4 || status == '4') {
        return "ออกนอกเขตเรือจ่ายน้ำมัน";
      }
      return "ปกติ";
    },
    getLatlng(res) {
      const { position_reports, icon_type } = res;
      const latLng = [];
      for (let i = 0; i < position_reports.length; i++) {
        latLng.push({
          lat: position_reports[i].latitude,
          lng: position_reports[i].longitude,
          ...position_reports[i],
          icon: icon_type
        });
      }
      this.data = latLng;
    },
    onSelectRow(val) {
      this.activeEl = val;
    },
    getReportDeatil() {
      const { call_sign } = this.report;
      return { call_sign };
    },
    print() {
      this.hide = true;
      setTimeout(() => {
        this.hide = false;
        window.print();
      }, 150);
    }
  }
};
</script>
<style>
.scroll-area--customizer-report {
  height: calc(100% - 6rem);
  width: 950px;
}
.detail-maps {
  border: 0;
  height: 400px;
  width: 900px;
  padding: 0px;
}

@media print {
  #selecttime {
    display: none;
  }
}
.active {
  font-weight: bold;
}
</style>